module.exports = __webpack_public_path__ + "img/outlook.c4edd8d9.png";